import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { variant } from 'styled-system';
import styled, { css } from 'styled-components';
import { get } from './constant';
import Button from '../components/Button';
import Icon from '../components/Icon';
import { spinnerAnimationStyled } from '../components/LoadingIndicator/loading-indicator.style';
const inputVariant = variant({
  prop: 'variant',
  variants: {
    "default": {
      border: '1px solid'
    },
    vanity: {
      borderBottom: '2px solid',
      borderTop: get('space.0'),
      borderLeft: get('space.0'),
      borderRight: get('space.0'),
      borderRadius: get('space.0'),
      paddingLeft: get('space.0'),
      paddingRight: get('space.0')
    }
  }
});
const inputErrorFocusVariant = variant({
  prop: 'variant',
  variants: {
    "default": {
      '&:focus': {
        borderColor: get('colors.feedback.danger.normal'),
        boxShadow: get('boxShadows.type.basic.danger')
      }
    },
    vanity: {
      '&:focus': {
        borderColor: get('colors.feedback.danger.normal'),
        boxShadow: get('boxShadows.type.vanity.danger')
      }
    }
  }
});
const inputFocusVariant = variant({
  prop: 'variant',
  variants: {
    "default": {
      '&:focus': {
        borderColor: get('colors.primary.blue.400'),
        boxShadow: get('boxShadows.type.basic.default')
      }
    },
    vanity: {
      '&:focus': {
        borderColor: get('colors.primary.blue.400'),
        boxShadow: get('boxShadows.type.vanity.default')
      }
    }
  }
});
const inputFit = variant({
  prop: 'fit',
  variants: {
    small: {
      height: get('space.32'),
      fontSize: get('fontSizes.s'),
      borderRadius: get('borderRadius.s'),
      padding: props => "".concat(get('space.0')(props), " ").concat(get('space.8')(props))
    },
    medium: {
      height: get('space.40'),
      fontSize: get('fontSizes.m'),
      borderRadius: get('borderRadius.m'),
      padding: props => "".concat(get('space.0')(props), " ").concat(get('space.12')(props))
    },
    large: {
      height: get('space.48'),
      fontSize: get('fontSizes.l'),
      borderRadius: get('borderRadius.m'),
      padding: props => "".concat(get('space.0')(props), " ").concat(get('space.16')(props))
    }
  }
});
const paddingVariant = variant({
  prop: 'fit',
  variants: {
    small: {
      paddingLeft: get('space.33')
    },
    medium: {
      paddingLeft: get('space.39')
    },
    large: {
      paddingLeft: get('space.47')
    }
  }
});
const clearButtonVariant = variant({
  prop: 'variant',
  variants: {
    plain: {
      '&:focus': {
        borderColor: get('colors.primary.blue.400'),
        boxShadow: get('boxShadows.type.basic.default')
      }
    }
  }
});
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), props => props.width ? "".concat(props.width, "%") : '100%');
const LoadingIndicator = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  right: 12px;\n  top: ", ";\n  & svg {\n    animation: ", ";\n    height: ", ";\n    width: ", ";\n  }\n  & .spinner {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n  & .track {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n"])), get('space.0'), spinnerAnimationStyled, props => props.fit === 'small' ? get('space.16') : get('space.24'), props => props.fit === 'small' ? get('space.16') : get('space.24'), get('colors.primary.blue.300'), get('colors.functional.grey.200'));
const inputActions = error => {
  if (error) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n      border-color: ", ";\n      &:hover {\n        border-color: ", "\n            : get('colors.functional.grey.600')};\n      }\n    "])), inputErrorFocusVariant, get('colors.feedback.danger.normal'), get('colors.feedback.danger.normal'));
  } else {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", ";\n      border-color: ", ";\n      &:hover {\n        border-color: ", ";\n      }\n    "])), inputFocusVariant, get('colors.functional.grey.400'), get('colors.functional.grey.600'));
  }
};
const IconDefaultStyle = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  justify-content: space-around;\n  top: 50%;\n  transform: translateY(-50%);\n"])), get('iconSize.small'), get('iconSize.small'));
const Prefix = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  right: unset;\n  left: ", ";\n  color: ", ";\n  font-size: ", ";\n"])), IconDefaultStyle, get('space.12'), get('colors.functional.grey.600'), props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'));
const Suffix = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n  left: unset;\n  color: ", ";\n  font-size: ", ";\n  right: ", ";\n"])), IconDefaultStyle, get('colors.functional.grey.600'), props => props.fit === 'small' ? get('fontSizes.14') : get('fontSizes.16'), get('space.17'));
const BasicInputStyle = "\n  box-sizing: border-box;\n  width: 100%;\n  transition: 0.2s ease;\n  transition-property: border, background-color;\n  color: ".concat(get('colors.functional.grey.800'), ";\n  box-shadow: none;\n  font-weight: ").concat(get('fontWeights.regular'), ";\n  outline: none;\n  &:disabled {\n    border-color: ").concat(get('colors.functional.grey.400'), ";\n    background-color: ").concat(get('colors.functional.grey.200'), ";\n    box-shadow: none;\n    color: ").concat(get('colors.functional.grey.500'), ";\n  }\n");
const InputIcon = styled(Icon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  pointer-events: ", ";\n  color: ", ";\n  ", ";\n  ", ";\n"])), IconDefaultStyle, props => props.disabled && 'none', props => props.disabled ? get('colors.functional.grey.500') : get('colors.functional.grey.600'), props => props.iconPosition === 'right' && variant({
  prop: 'fit',
  variants: {
    small: {
      left: 'unset',
      right: get('space.8')
    },
    medium: {
      left: 'unset',
      right: get('space.12')
    },
    large: {
      left: 'unset',
      right: get('space.16')
    }
  }
}), props => props.iconPosition === 'left' && variant({
  prop: 'fit',
  variants: {
    small: {
      left: get('space.8'),
      right: 'unset'
    },
    medium: {
      left: get('space.12'),
      right: 'unset'
    },
    large: {
      left: get('space.16'),
      right: 'unset'
    }
  }
}));
const ClearIconButton = styled(Button)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n  border:transparent;\n  right: ", ";\n  &:focus-visible {\n    outline: none;\n  }\n  &:focus {\n    border: unset;\n    box-shadow: unset;\n  }\n  &:hover {\n    background: transparent;\n  }\n"])), clearButtonVariant, props => props.issuffix && get('space.40'));
const inputRangeFit = variant({
  prop: 'fit',
  variants: {
    small: {
      padding: get('space.0'),
      height: get('space.2')
    },
    medium: {
      padding: get('space.2'),
      height: get('space.4')
    },
    large: {
      padding: get('space.4'),
      height: get('space.6')
    }
  }
});
const thumbFit = variant({
  prop: 'fit',
  variants: {
    small: {
      width: get('space.12'),
      height: get('space.12')
    },
    medium: {
      width: get('space.14'),
      height: get('space.14')
    },
    large: {
      width: get('space.18'),
      height: get('space.18')
    }
  }
});
const Components = {
  Wrapper,
  ClearIconButton,
  InputIcon
};
export { inputRangeFit, thumbFit, inputActions, inputErrorFocusVariant, inputFit, inputFocusVariant, inputVariant, paddingVariant, BasicInputStyle, ClearIconButton, LoadingIndicator, Prefix, Suffix, Components };